export function getCookie(name) {
    const cookiePairs = document.cookie.split('; ');
    for (const pair in cookiePairs) {
        if (pair.startsWith(name)) {
            const i = pair.indexOf('=');
            if (i > -1)
                return pair.substring(i + 1);
            break;
        }
    }
    return undefined;
}
